import React from 'react'
import img from './photo-output.PNG'
import { FaInstagram, FaFacebookF } from "react-icons/fa";

const Footer = () => {
  return (
    <div className='bg-black text-white'>
      <div className="mx-auto p-4 lg:container">
        <div className="grid grid-cols-1 gap-4 py-8 lg:grid-cols-4">
          <div className='p-2 space-y-3'>
            <img width={60} height={50} src={img} alt="" />
            <p>Naija prime is a site aimed at exploring Nollywood home movies, giving the best of entertainment.</p>
            <div className="flex space-x-2">
              <h4><a href="https://www.instagram.com/naijaprime" target="_blank" rel="noreferrer"><FaInstagram /></a></h4>
              <h4><a href="https://www.facebook.com/Realnaijaprime?mibextid=LQQJ4d" target="_blank" rel="noreferrer"><FaFacebookF /></a></h4>
            </div>
          </div>
          <div className='p-2'>
            <h3>Company</h3>
            <ul className='space-y-2'>
              <li><a href="/">FAQs</a></li>
              <li><a href="/">Blog</a></li>
              <li><a href="/">Career</a></li>
            </ul>
          </div>
          <div className='p-2'>
            <h3>Company</h3>
            <ul className='space-y-2'>
              <li><a href="/">Terms of Service</a></li>
              <li><a href="/">Privacy Policy</a></li>
            </ul>
          </div>
          <div className='p-2'>
            <h3>Contact Us</h3>
            <h4>Email:  naijaprime@gmail.com</h4>
            <br />
            <h4>Address:</h4>
            <p>Nigeria</p>
          </div>
        </div>
        <div className='text-center py-2'>
          <h5><b className='text-green-500'>Naija Prime</b> <br /> (Home of Nollywood Movies)</h5>
        </div>
      </div>
      <hr />
      <div  className="text-center py-6">
        <span>&copy; Copyright NaijaPrime - All rights reserved.</span>
      </div>
    </div>
  )
}

export default Footer
